module.exports = __webpack_public_path__ + "img/equipment-icon.4f39d683.svg";